import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import Row from '../../../../core/layout/Row';
import Column from '../../../../core/layout/Column';
import TextInput from '../../../../core/form/TextInput';
import SlicesInputContainer from '../inputs/SlicesInputContainer';
import GrammarCheckAnswersInputContainer from '../inputs/GrammarCheckAnswersInputContainer';

const GrammarCheckItemForm = (props) => (
  <div>
    <Row>
      <Column size={12}>
        <TextInput
          required
          label="Text"
          fieldType="textarea"
          disabled={props.submitting || props.disabled}
          value={get(props.values, 'text', '')}
          onChange={(value) => props.onChange('text', value)}
          errorText={get(props.errors, 'text', '')}
        />
      </Column>
    </Row>
    <SlicesInputContainer
      onChange={(textSlices) => {
        const slices = textSlices.map((slice) => ({
          word: slice.text,
          index: slice.index,
          ...(slice.linkTo && { linkTo: slice.linkTo }),
        }));
        props.onChange('slices', slices);
        props.onChange(
          'indexesToRemove',
          textSlices.filter((slice) => slice.index !== undefined)
        ); // this is to show errors
      }}
      text={get(props.values, 'text', '')}
      value={get(props.values, 'slices', []).map((slice) => ({
        text: slice.text || slice.word,
        index: slice.index,
        ...(slice.linkTo && { linkTo: slice.linkTo }),
      }))}
      errorText={get(props.errors, 'indexesToRemove', '')}
      label="Which word or expression is wrong in original sentence:"
      allowLinkSlices
      disabled={props.disabled}
      isCorrect={false}
      color="#ce1d0c"
    />
    <GrammarCheckAnswersInputContainer
      onChange={props.onChange}
      disabled={props.disabled}
      errors={props.errors}
      submitting={props.submitting}
      values={props.values}
    />
  </div>
);

GrammarCheckItemForm.propTypes = {
  values: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.object,
  submitting: PropTypes.bool,
  disabled: PropTypes.bool,
};

GrammarCheckItemForm.defaultProps = {
  values: {},
  errors: {},
  submitting: false,
  onChange: () => false,
  disabled: false,
};

export default GrammarCheckItemForm;
